import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { HdAccessoryFile, HdAccessoryGroup } from "./hd-accessory-list.service";

@Component({
  selector: "hd-accessory-list",
  templateUrl: "./hd-accessory-list.component.html",
  styleUrls: ["./hd-accessory-list.component.less"],
})
export class HdAccessoryListComponent implements OnInit {
  /** 分组列表：每项含 name + accessoryList */
  @Input() groups: Array<HdAccessoryGroup> = [];
  /** 分组标签后是否自动加冒号，默认 true */
  @Input() labelColon: boolean = true;
  /** 点击附件时是否默认 window.open 下载/查看，默认 true */
  @Input() autoOpen: boolean = true;

  /** 点击附件回调（在 autoOpen 之前触发） */
  @Output() fileClick = new EventEmitter<{
    group: HdAccessoryGroup;
    file: HdAccessoryFile;
    path: string;
  }>();

  constructor() {}

  ngOnInit() {}

  getFileName(file: HdAccessoryFile): string {
    if (!file || file.name == null) {
      return "";
    }
    return String(file.name);
  }

  getFilePath(file: HdAccessoryFile): string {
    if (!file || file.path == null) {
      return "";
    }
    return String(file.path);
  }

  getFileSizeText(file: HdAccessoryFile): string {
    if (!file) {
      return "";
    }
    const raw = file.size;
    if (raw == null || raw === "") {
      return "";
    }
    if (typeof raw === "string") {
      return raw;
    }
    const bytes = Number(raw);
    if (isNaN(bytes) || bytes < 0) {
      return "";
    }
    if (bytes < 1024) {
      return bytes + " B";
    }
    if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0) + " KB";
    }
    return (
      (bytes / (1024 * 1024)).toFixed(bytes < 10 * 1024 * 1024 ? 1 : 0) + " MB"
    );
  }

  getLabelText(group: HdAccessoryGroup): string {
    const name = group && group.name != null ? String(group.name) : "";
    if (!name) {
      return "";
    }
    if (!this.labelColon) {
      return name;
    }
    return /[:：]$/.test(name) ? name : name + "：";
  }

  onFileClick(
    group: HdAccessoryGroup,
    file: HdAccessoryFile,
    event: Event,
  ): void {
    if (event) {
      event.preventDefault();
    }
    const path = this.getFilePath(file);
    this.fileClick.emit({ group, file, path });
    if (this.autoOpen && path) {
      window.open(path, "_blank");
    }
  }

  // 用箭头函数：ngFor 的 trackBy 调用时不会绑定组件 this
  trackByGroup = (index: number, group: HdAccessoryGroup): any => {
    return (group && group.name) || index;
  };

  trackByFile = (index: number, file: HdAccessoryFile): any => {
    return this.getFilePath(file) || this.getFileName(file) || index;
  };
}
